/** Сезон и обмен заглушки. */
import type { PlayerState } from "../api";

export function sampleSeasonFields(): Pick<
  PlayerState,
  "season" | "crystals" | "skipTickets" | "speedTickets" | "speedUntil"
> {
  return {
    season: null,
    crystals: 0,
    skipTickets: 0,
    speedTickets: 0,
    speedUntil: null,
  };
}
